export default __webpack_public_path__ + "static/media/image11.2015ac3d.jpg";